export default class JobExperiencesFieldsNames {
    static readonly ExperiencesName = 'experiences';
}
